module.exports = "https://static.wmbcdn.com/uniweb/images/e0f201319d882575cf8c211b2f835e2a.svg";